import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=1ad0fe09&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppFooter.vue?vue&type=style&index=1&id=1ad0fe09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad0fe09",
  null
  
)

export default component.exports